import type { CanManageDevelopmentUser } from '@/presentation/pages/developments/utils/resolve-can-manage-development.js';
import { resolveCanManageDevelopment } from '@/presentation/pages/developments/utils/resolve-can-manage-development.js';

export type CanCreateDevelopmentUser = CanManageDevelopmentUser;

export function resolveCanCreateDevelopment(user: CanCreateDevelopmentUser): boolean {
    return resolveCanManageDevelopment(user);
}
